import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheShiftPremissionEditsActions,
  SetTheShiftPremissionRetrieveActions,
  setTablePositionPersist
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/LeavePermission/LeavePermission.scss";
import { data } from "jquery";
const ShPermissionApprove = (props) => {
  const { currentPage, setShow, show, EditId, data, selectVal , white_collar , Datestate , to_date ,from_date , search }  = props;
  // console.log(white_collar , "white_collar");
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const initialState = {
    from_date: "",
    to_date: "",
    continue_leave: "",
    status: "",
    notes: "",
    applied_date: "",
    user_id: "",
    leave_type: "",
    certificate_id: "",
    client_id: "",
    description: "",
    user_name: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheShiftPremissionRetrieveActions({ EditId }));
  }, []);
  useEffect(() => {
    console.log(state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus, "datas");
    if (state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.id != undefined) {
      const dateString =
        state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        // leave_type:
        // state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.leave_type
        // .leave_type,
        status: state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.status,
        from_date:
          state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.from_time,
        to_date: state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.to_time,
        notes: state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.notes,
        user_name:
          state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.user_id
            .first_name,
        description:
          state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus
            .reason_for_decline,
        client_id:
          state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.client_id != null ?

            state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.client_id.client_name :"",
        // applied_date:
        // state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus.applied_date.slice(
        // 0,
        // 10
        // ) +
        // "  " +
        // formattedTime,
      });
    }
  }, [state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
      const newEntry = { isApproved: true };
    const result = { ...TablePositionPersist.PermissionRequestPage, ...newEntry };
    dispatch(
      setTablePositionPersist({
        data: result,
        pageName: "PermissionRequestPage",
      })
    ); 

    const payload = {
      status: Data.status.toLowerCase(),
      EditId: EditId,
      description:
        Data.status.toLowerCase() == "decline" ? Data.description : "",
      currentPage: currentPage,
      data: data,
      selectVal: selectVal,
      white_collar:white_collar, 
      from_date:from_date, 
      to_date:to_date,
      search:search
    };
    dispatch(SetTheShiftPremissionEditsActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Employee Shift Permission</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD ">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Note
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.notes}
                            readOnly
                          />
                        </div>
                    
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3">
                          <div className="row">
                            <div
                              className="col-12"
                              style={{ marginTop: "15px" }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label-Header"
                              >
                                Leave
                              </label>
                            </div>
                            <div className="row" style={{ marginLeft: "5px" , marginRight:"3px" }}>
                              <div className="col">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  From
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.from_date}
                                  readOnly
                                />
                              </div>
                              <div className="col">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  To
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.to_date}
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                  
                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>

                        {Data.status.toLowerCase() == "decline" ? (
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.ShiftPermissionRetrieveCall.ShiftRetrieveStatus
                            .status == Data.status.toLowerCase()
                        }
                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShPermissionApprove;
